export class ResponseMessage<T> {
  constructor(
    public message: string,
    public responseCode: number,
    public success: boolean,
    public result: T
  ) {}

  static fromJson<T>(json: any): ResponseMessage<T> {
    return new ResponseMessage<T>(
      json.message,
      json.responseCode,
      json.success,
      json.result
    );
  }
}
